<div class="employee-name">
    <app-employee-image [employeeId]="employee?.id" [width]="35" [height]="35" [round]="true"></app-employee-image>

    <span class="employee">
        {{employee?.firstName}} {{employee?.lastName}}
    </span>
</div>